<template>
     <NavbarSection />
    <!-- <div class="container-fluid">
        <NavbarSection />
    </div> -->
    <div class="headerContainer">
        <h2>Upcoming Tournaments</h2>
        <p>Contact us today to schedule a tour, learn about membership options, or book your first tennis session at
            Lagos' premier tennis destination.</p>
    </div>

    <!-- Search Bar -->
    <div class="search-bar">
        <input v-model="searchQuery" type="text" placeholder="Search for an event..." class="search-input" />
    </div>

    <!-- Sports Event Cards -->
    <div class="events-grid">
        <div v-for="event in filteredEvents" :key="event.id" class="event-card">
            <img :src="event.image" :alt="event.name" />
            <h3>{{ event.name }}</h3>
            <div class="map-venue">
                <MapPin />
                <p>{{ event.venue }}</p>
            </div>
            <p style="margin-top: 10px; margin-bottom: 10px;">{{ event.description }}</p>
            <div class="map-venue">
                <Calendar />
                <p>{{ event.date }}</p>
            </div>
            <div class="map-venue">
                <UsersRound />
                <p>{{ event.perticipant }}</p>
            </div>
            <button @click="goToRegistration">Register</button>
        </div>
    </div>
    <!-- <div class="see-all">
        <button class="see-all-event">
            <p>See All Events</p>
            <MoveRight />
        </button>
    </div> -->
    <ReusableAccordion />

    <!-- Tournament Registration Modal -->
    <div class="modal fade" id="tournamentModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Tournament Event Registration</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- Registration Form -->
                <form id="tournamentForm">
                    <div class="modal-body text-start">
                        <!-- Personal Information Section -->
                        <div class="mb-4">
                            <h6 class="border-bottom pb-2 mb-3">Personal Information</h6>
                            
                            <!-- Full Name -->
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label class="form-label">First Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="firstName" required placeholder="Enter first name">
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Last Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="lastName" required placeholder="Enter last name">
                                </div>
                            </div>

                            <!-- Gender and Age -->
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label class="form-label">Gender <span class="text-danger">*</span></label>
                                    <select class="form-select" v-model="gender" required>
                                        <option value="">Select gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                        <option value="prefer_not_to_say">Prefer not to say</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Age <span class="text-danger">*</span></label>
                                    <input type="number" class="form-control" v-model="age" required min="1" max="100" placeholder="Enter age">
                                </div>
                            </div>

                            <!-- Contact Information -->
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                                    <input type="tel" class="form-control" v-model="phoneNumber" required placeholder="Enter phone number">
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Email Address <span class="text-danger">*</span></label>
                                    <input type="email" class="form-control" v-model="emailAddress" required placeholder="Enter email address">
                                </div>
                            </div>

                            <!-- Club Name -->
                            <div class="mb-3">
                                <label class="form-label">Club Name <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="clubName" required placeholder="Enter club name">
                            </div>
                        </div>

                        <!-- Tournament Information Section -->
                        <div class="mb-4">
                            <h6 class="border-bottom pb-2 mb-3">Tournament Details</h6>
                            
                            <!-- Tournament Type -->
                            <div class="mb-3">
                                <label class="form-label">Tournament Type <span class="text-danger">*</span></label>
                                <select class="form-select" v-model="tournamentType" required>
                                    <option value="">Select tournament type</option>
                                    <option value="singles">Singles</option>
                                    <option value="doubles">Doubles</option>
                                    <option value="mixed_doubles">Mixed Doubles</option>
                                    <option value="junior">Junior Tennis</option>
                                    <option value="adult">Adult Tennis</option>
                                    <option value="senior">Senior / Veteran Tennis</option>
                                </select>
                            </div>

                            <!-- Junior Category (Conditional) -->
                            <div class="mb-3" v-if="tournamentType === 'junior'">
                                <label class="form-label">Junior Category <span class="text-danger">*</span></label>
                                <select class="form-select" v-model="juniorCategory" required>
                                    <option value="">Select age group</option>
                                    <option value="u10">Under 10</option>
                                    <option value="u12">Under 12</option>
                                    <option value="u14">Under 14</option>
                                    <option value="u16">Under 16</option>
                                    <option value="u18">Under 18</option>
                                </select>
                            </div>

                            <!-- Participant Name (Conditional for Junior) -->
                            <div class="mb-3" v-if="tournamentType === 'junior'">
                                <label class="form-label">Participant (if different from above) <span class="text-danger">*</span></label>
                                <input type="text" v-model="participant" class="form-control" placeholder="Enter participant name">
                                <small class="text-muted">If participant is different from registered person (e.g., parent registering for child)</small>
                            </div>

                            <!-- Team Category -->
                            <div class="mb-3">
                                <label class="form-label">Team Category <span class="text-danger">*</span></label>
                                <select class="form-select" v-model="teamCategory" required>
                                    <option value="">Select team</option>
                                    <option value="treasures">Treasures</option>
                                    <option value="trailblazers">Trailblazers</option>
                                    <option value="titans">Titans</option>
                                    <option value="terminators">Terminators</option>
                                </select>
                            </div>
                        </div>

                        <!-- Terms and Conditions -->
                        <div class="mb-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="agreeTerms" id="agreeTerms" required>
                                <label class="form-check-label" for="agreeTerms">
                                    I agree to the <a href="#" @click.prevent="showTerms">terms and conditions</a> and understand the tournament rules
                                </label>
                            </div>
                        </div>

                        <!-- Payment Notice -->
                        <div class="alert alert-info mb-0">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="bi bi-info-circle"></i>
                                </div>
                                <div class="flex-grow-1 ms-3">
                                    <strong>Registration Fee:</strong> {{ registrationFee }}<br>
                                    <strong>Payment Method:</strong> Paystack (Card, Bank Transfer, USSD)<br>
                                    <small class="text-muted">Registration is only confirmed after successful payment</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal Footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-success" @click="payWithPaystack()" :disabled="!agreeTerms">
                            {{ continue_registration }} - {{ registrationFee }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <FooterSection />
</template>


<script setup>

import { ref, onMounted, computed } from 'vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ReusableAccordion from '@/components/ReusableAccordion.vue';
import { Calendar, MapPin, UsersRound } from 'lucide-vue-next';
//import eventimage from "../assets/images/sports/eventimage.jpg"
import FooterSection from '@/components/FooterSection.vue';
import PaystackPop from '@paystack/inline-js';
import axios from 'axios';
import router from "@/router";
import { Modal } from 'bootstrap';

const loggedId = ref(localStorage.getItem('userid'));
const tournamentType = ref('');
const junior_category = ref('')
const participant = ref('')
const team = ref('')
const email_address = ref(localStorage.getItem('email_address'));
const event_fees = ref([])
const event_status = ref([])
const searchQuery = ref('');
const continue_registration = ref('')
const registrationFee = ref('')
const registration_info = ref('')

const sportsEvents = ref([]);

const filteredEvents = computed(() => {
    return sportsEvents.value.filter((event) =>
        event.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
});

onMounted(async () => {
        await listRecords()
});
  
const listRecords = async () => {
    try {
    const response = await axios.get('/tournament_lists.php', { });
    if (response.data.status) sportsEvents.value = response.data.data;
    else console.error(response.data.message);
    } catch (error) {
    console.error(error.message);
    }
};

const goToRegistration = (card) => {
    if (card.status !== 'open') {
        // what happens when registration is closed
        alert('Registration for this event is currently closed.');
        return;
    }
    
    if (card.event_status === 'free') {
        registration_info.value = "This event does not require payment to complete registration."
        continue_registration.value = "Submit";
    }
    else if (card.event_status === 'paid') {
        registration_info.value = "Payment is required to complete this registration"
        continue_registration.value = "Proceed to Payment";
    }

    // if user not logged in
    if (!loggedId.value) {
        router.push('/login/registerEvent');
        return;
    }
    event_fees.value = card
    event_status.value = card
    // open registration modal
    const modal = new Modal(document.getElementById('tournamentModal'));
    modal.show();
};

// const formatDate = (dateString) => {
// const date = new Date(dateString);

// const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
// const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

// return {
//         month: months[date.getMonth()],
//         dayNumber: String(date.getDate()).padStart(2, "0"),
//         dayText: days[date.getDay()]
//     };
// }

const payWithPaystack = () => {
//console.log(event_fees.value)
if (!tournamentType.value) {
alert('Please select a tournament type.');
return;
}

if (tournamentType.value === 'junior' && !junior_category.value) {
alert('Please select a junior category.');
return;
}

if (!team.value) {
alert('Please select a team.');
return;
}

if (!email_address.value) {
    alert('Your email address is missing. Please update your email address.');
    return;
}

if (event_status.value.event_status === 'paid') {
    const paystack = new PaystackPop();

    paystack.newTransaction({
        key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
        email: email_address.value,
        amount: Number(event_fees.value.program_fee) * 100,

        onSuccess: (transaction) => { 
            // Payment complete! Reference: transaction.reference 
            const payment_ref = transaction.reference 
            createPayment(event_fees.value, payment_ref, event_status.value.event_status, tournamentType.value, junior_category.value, team.value)
        },
        onCancel: () => {
            // user closed popup
        }
    });
}

createPayment(event_fees.value, 'payment_ref', event_status.value.event_status, tournamentType.value, junior_category.value, team.value)

}

const createPayment = async (data, reference, event_status, tournament, junior, teams) => {
try {
    const response = await axios.post('/event_payment.php', { user_id: loggedId.value, event_id: data.id, amount: data.program_fee, email: email_address.value, description: reference, event_status: event_status, payment_status: 'event-booking', tournament_type: tournament, junior_category: junior, participant: participant.value, teams: teams });
    if (response.data.status) {
    alert(response.data.message) 
    window.location.reload();
    }
    else console.error(response.data.message);
} catch (error) {
    console.error(error.message);
}
};

</script>


<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/sports/bookcompetition.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding: 1.5rem 4rem 0 4rem;

    .heroWriteup {
        position: absolute;
        max-width: 650px;
        text-align: left;
        bottom: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 52px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        button {
            background-color: #F3F4F6;
            width: 296px;
            height: 64px;
            border-radius: 40px;
            border: 4px solid #ED4E241A;
            margin-top: 2rem
        }
    }

}

.map-venue {
    display: flex;
    justify-content: start;
    align-items: start;
    gap: 10px;
    margin-top: 10px;
    color: #6D6D6D;
}

.search-bar {
    display: flex;
    justify-content: center;
    margin: 2rem 0;

    .search-input {
        width: 100%;
        max-width: 400px;
        padding: 10px 15px;
        border: 2px solid #ddd;
        border-radius: 30px;
        font-size: 16px;
        outline: none;
        transition: border-color 0.3s ease;

        &:focus {
            border-color: #ed4e24;
        }
    }
}

/* Events Grid */
.events-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    padding: 20px;
    max-width: 1240px;
    margin: auto;

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }

    .event-card {
        background: #fff;
        border-radius: 28px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        padding: 14px;
        text-align: center;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 1px solid #E7E7E7;

        img {
            width: 100%;
            object-fit: cover;
            border-radius: 22px;
            margin-bottom: 15px;
        }

        h3 {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
            text-align: left;
        }

        p {
            font-size: 14px;
            color: #6D6D6D;
            margin-bottom: 5px;
            text-align: left;
            font-weight: 400;
        }

        button {
            width: 100%;
            border-radius: 50px;
            background-color: #ED4E24;
            height: 52px;
            margin-top: 20px;
            border: 4px solid #E306132B;
            color: white;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
        }
    }
}

.headerContainer {
    width: 100%;
    margin-top: 30px;

    h2 {
        font-size: 52px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000;
    }

    p {
        font-size: 18px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000CC;
    }
}


.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background-color: rgba(8, 34, 20, 0.5);
    /* black with 40% opacity */
    z-index: 1;
}

.herosection>* {
    position: relative;
    z-index: 2;
    /* keep content above the overlay */
}

.pioneers-section {
    margin-top: 5rem;

    h2 {
        font-size: 48px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        margin-bottom: 4rem;
    }
}

.see-all {
    width: 70%;
    margin: auto;
    display: flex;
    justify-content: end;
    align-items: end;

}

.see-all-event {
    background-color: transparent;
    color: #ED4E24;
    display: flex;
    border: none;
    justify-content: center;
    align-items: center;
    gap: 10px;

    p {
        margin: 0%;
        padding: 0%;
    }
}


@media (max-width: 768px) {

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }

    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 90%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #ffffff;
                border: 2px solid #0000001f;
                color: black;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }
}
</style>
